
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'

export default {
components: {
XButton,
Box,
Flexbox,
FlexboxItem,
Swiper,
IndexHeader,
IndexSidebar,
IndexFooter
},
data () {
return {
swiperList: [
{
url: 'javascript:',
img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_jrtt.png'
},
{
url: 'javascript:',
img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_gdt.png'
},
{
url: 'javascript:',
img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_wxgg.png'
},
{
url: 'javascript:',
img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_wbfst.png'
},
{
url: 'javascript:',
img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_mm.png'
},
{
url: 'javascript:',
img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_UCtt.png'
}
],
swiperTexts: [
{
hightLightTitle: '今日头条是一款基于数据挖掘的推荐引擎产品',
text01: '是国内互联网领域成长最快的产品服务之一，是目前资讯类信息流平台最大的平台。',
title02: '【支持跳转H5页面、一键下载APP】',
text02: '今日头条累计激活用户数已达5.5亿，日活跃用户超6000万+，用户每日使用时长超过76分钟，同时能5秒快速推广，10秒更新用户模型，为对的用户推送对的广告。'
},
{
hightLightTitle: '广点通包含手机腾讯网、QQ空间等众多资源。',
text01: '通常投放的比较多的是feeds广告',
title02: '',
text02: '平台拥有8亿QQ用户、20亿+移动端日均流量、100亿+PC端日均流量，同事适合多种类型的APP投放，实现自助精准投放'
},
{
hightLightTitle: '微信广告包括朋友圈广告和公众号广告',
text01: '以类似朋友圈原创内容形式或者在公众号内部进行展现，可支持跳转到公众号加关注、公众号图文信息以及H5页面、应用下载',
title02: '',
text02: '微信属于社交应用排名NO.1，1.9%公众号平均广告点击率朋友圈广告枪战每日12点、18点前后曝光高峰值，实现品牌广告有效转化'
},
{
hightLightTitle: '微博“粉丝通”是基于用户兴趣，将企业广告广泛传递给粉丝和潜在粉丝的营销产品。',
text01: '同时它拥有7大信息流广告展现形式。粉丝通商业化成熟，是目前大多数广告主必投的渠道。',
title02: '',
text02: '拥有6.5亿注册用户，3.9亿月活跃用户，同时移动端日活跃用户占比达91%，通过移动社交实现原生传播。'
},
{
hightLightTitle: '陌陌是一款基于地理位置的移动社交产品。',
text01: '基于陌陌海量的用户数据，广告引擎智能匹配目标受众，商家可以与用户进行实时对话，开展新客源，维系老客户。',
title02: '',
text02: '具有3亿总注册用户量，人均打开次数10次/天，月活跃用户为7480万，是中国TOP1的LBS社交广告平台，广告点击率高于行业平均值10倍以上。'
},
{
hightLightTitle: 'UC头条广告平台主打基于大数据分析用户兴趣标签的信息流广告投放',
text01: '一方面由UC提供海量流量资源，另一方面则由阿里妈妈提供专业的广告后台和服务支持。',
title02: '',
text02: '全球UC浏览器用户达到5亿+，日活跃用户突破1亿+，日点赞数高达40亿，个性化推荐，精准分析和内容匹配能力，平均CPC（单次点击价格）低于同行业。'
}
],
currentSwiperText: {}
}
},
methods: {
handleSwiperChange (idx) {
this.currentSwiperText = this.swiperTexts[idx]
}
},
mounted () {
this.currentSwiperText = this.swiperTexts[0]
}
}



// WEBPACK FOOTER //
// ./src/pages/promotionInfoFlow/index.vue